import { z } from "zod";
export const optionalId = z.coerce.number().int().min(1).optional();
export const requiredId = z.coerce.number().int().min(1);
export const optionalNumber = z.coerce.number().int().nonnegative().optional().nullable();
export const optionalMinNumber = z.coerce.number().int().min(1).optional().nullable();
export const requiredNumber = z.coerce.number().int().nonnegative();
export const optionalNonEmptyText = z.string().trim().min(1).optional();
export const optionalText = z.string().trim().optional().nullable();
export const requiredText = z.string().trim().min(1);
export const optionalBoolean = z.boolean().optional();
export const requiredBoolean = z.boolean();
export const optionalDefaultBoolean = (defaultVal) => z.boolean().default(defaultVal).optional();
export const requiredDefaultBoolean = (defaultVal) => z.boolean().default(defaultVal);
export const optionalDate = z.coerce.date().optional().nullable();
export const requiredDate = z.coerce.date();
export function hasAtLeastOneField(value) {
    return Object.values(value).some((field) => field !== undefined);
}
